import { T, always, append, compose, concat, cond, converge, endsWith, equals, head, is, isNil, join, map, not, o, pipe, reduce, replace, slice, split, tail, toLower, toPairs, toUpper, unless } from "ramda";
import { str } from '../../utils/di';

export const toStartCase = unless(isNil, replace(/^./, toUpper));

export const toSnakeCase = replace(/\s+/g, '_');

export const toKebabCase = replace(/\s+/g, '-');

export const toPascalCase = compose(join(''), map(toStartCase), split(/\s+/g));

export const toTitleCase = o(toStartCase, unless(isNil, toLower));

export const pluralize = unless(
  (x) => not(endsWith('s', x)),
  (str: string) => append('s', Array.from(str))
);

export const singularize = (s: string) =>
  unless(
    (x) => not(endsWith('s', x)),
    (str: string) => slice(0, -1, str)
  )(s);

type CaseOption = "sentence" | "upper" | "lower" | "sentence_capitalized" | ((str: string) => string);

export const format = (
  target: string,
  options: {
    replacements: { [key: string]: string },
    case: CaseOption
  }
): string => {
    const { replacements, case: caseOption } = options;

    // Perform replacements
    const replacePlaceholders = (str: string, [key, value]: [string, string]) => {
      const regex = new RegExp(`\\{${key}\\}`, 'g');
      return str.replace(regex, value);
    };

    let result = reduce(replacePlaceholders, target, toPairs(replacements));

    // Adjust case
    const adjustCase = cond([
      [is(Function) as any, ((caseOption as any)(result))],
      [equals("upper"), toUpper(result)],
      [equals("lower"), toLower(result)],
      [equals("sentence"), toTitleCase(result)],
      [equals("sentence_capitalized"), result.replace(/(^\w|\.\s*\w)/g, c => c.toUpperCase())],
      [T, result] // Default case
    ]);

    result = adjustCase(caseOption) as string;

    return result;
  }
